module.exports = __webpack_public_path__ + "img/labuan.6939afbf.png";